var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown-item',{attrs:{"data-testid":"delete-member-dropdown-item"},on:{"action":function($event){return _vm.showRemoveMemberModal(_vm.modalData)}},scopedSlots:_vm._u([{key:"list-item",fn:function(){return [_c('span',{staticClass:"gl-text-red-500"},[_vm._t("default")],2)]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }